import React , {useState} from 'react';
import './index.scss';
import { useHistory, useParams } from 'react-router-dom';

import NewsItemDetail from '../../components/templates/newsItemDetail/newsItemDetail';
import {Routes} from "../../../routes";
import CategoryService from "../../shared/services/CategoryService";
import PSLoading from "../../components/PSLoading";
import {mapToSelect} from "../../../scripts/Util";
import EntityService from "../../shared/services/EntityService";
import {showErrorToast, showSuccessToast} from "../../shared/constants/Constants";

export default function NewsItemPage() {
  const {id} = useParams();

  const history = useHistory();
  const [loading, setLoading] = useState(true);
  const [listCategories, setListCategories] = useState([]);
  const [loadSave, setLoadSave] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [newsCreate, setNewsCreate] = (useState({
    idEntity:'1',
    idCategory:'',
    title:'',
    description:'',
    author:'',
    photo:null
  }));

  const onGoBack = ()=>{
    history.push(Routes.CMS_NEW);
  };


  const loadCategory =  async (id) => {
    try{
      const response = await CategoryService.responseGetCategory();
      setLoading(false);
      setListCategories([...mapToSelect(response.data,"id","description")]);
    }catch (error){
      setLoading(false);
    }
  };

  const loadNews=  async (id) => {
    try{
      setIsEdit(true);
      setLoading(true);
      const response = await EntityService.responseGetEntityById(id);

      const loadNews = {
        idEntity: response.data.idEntity,
        idCategory: response.data.idCategory,
        title: response.data.title,
        description: response.data.description,
        photo: response.data.linkPhoto,
        author : response.data.customField,
      };
      setNewsCreate({...loadNews});
      setLoading(false);
    }catch (error){
      setLoading(false);
    }
  };

  const onChangeNews = (property,value)=>{
    newsCreate[property]=value;
    setNewsCreate({...newsCreate});
  };
  const validateFieldNews = (newsCreate) => {
    let isValid = true;

    Object.values(newsCreate).forEach( item=>{
      if(!item){
        isValid =false;
      }
    });
    return isValid;

  };

  const onSaveNews = async () => {
    try{
      const isValid = validateFieldNews(newsCreate);
      if(isValid){
        setLoadSave(true);
        let formData = new FormData();
        formData.append('idEntity', newsCreate.idEntity);
        formData.append('idCategory', newsCreate.idCategory);
        formData.append('title', newsCreate.title);
        formData.append('description', newsCreate.description);
        formData.append('photo',newsCreate.photo);
        formData.append('customField',newsCreate.author);
        const response  = await EntityService.responseSaveEntity(formData);
        const linkPhoto = response.data.linkPhoto;
        const dateFormatCreated = new Date(response.data.dateCreated).toLocaleDateString('es');
        setNewsCreate({...newsCreate, linkPhoto:linkPhoto, date: dateFormatCreated});
        showSuccessToast('Se creó la noticia con éxito');
        setLoadSave(false);
        return true;
      }else{
        showErrorToast('Debe ingresar los campos requeridos');
        return false;
      }
    }catch (error){
      setLoadSave(false);
      showErrorToast('Error al crear noticia');
    }
  };

  const onEditNews = async () => {
    try{
      const isValid = validateFieldNews(newsCreate);
      if(isValid){
        setLoadSave(true);
        let formData = new FormData();
        formData.append('idEntity', newsCreate.idEntity);
        formData.append('idCategory', newsCreate.idCategory);
        formData.append('title', newsCreate.title);
        formData.append('description', newsCreate.description);
        formData.append('photo',newsCreate.photo);
        formData.append('customField',newsCreate.author);
        const response  = await EntityService.responseEditEntity(formData, id);
        const linkPhoto = response.data.linkPhoto;
        const dateFormatCreated = new Date(response.data.dateCreated).toLocaleDateString('es');
        setNewsCreate({...newsCreate, linkPhoto:linkPhoto, date: dateFormatCreated});
        showSuccessToast('Se edito la noticia con éxito');
        setLoadSave(false);
        return true;
      }else{
        showErrorToast('Debe ingresar los campos requeridos');
        return false;
      }
    }catch (error){
      setLoadSave(false);
      showErrorToast('Error al crear noticia');
    }
  };

  useState(()=>{
    loadCategory();
  },[]);


  useState(()=>{
    if(id){
      loadNews(id);
    }

  },[id]);


  return(
    <div>
      {
        loading ?
          <div className="d-flex-center">
            <PSLoading color="red"/>
          </div> :
          <NewsItemDetail
            listCategories={listCategories}
            onChangeNews={onChangeNews}
            onGoBack={onGoBack}
            onSaveNews={onSaveNews}
            onEditNews={onEditNews}
            loadSave={loadSave}
            newsCreate={newsCreate}
            isEdit= {isEdit}
          />
      }
    </div>
  )
}